import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  AiFillGithub,
} from "react-icons/ai";
import { FaFacebookF, FaDiscord, FaLinkedinIn } from "react-icons/fa";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <Container fluid className="footer bg-black border-t border-white/5 py-12">
      <Row className="items-center">
        <Col md="4" className="footer-copywright text-left">
          <h3 className="text-zinc-500 text-sm font-bold uppercase tracking-widest leading-loose">
            Developed by <br />
            <span className="text-white">Crizneil</span>
          </h3>
        </Col>
        <Col md="4" className="footer-copywright text-center">
          <h3 className="text-zinc-500 text-sm font-bold uppercase tracking-widest">
            Copyright © {year} <span className="text-brand">CB</span>
          </h3>
        </Col>
        <Col md="4" className="footer-body">
          <ul className="footer-icons flex justify-end gap-3 list-none m-0 p-0">
            <li className="social-icons !m-0">
              <a
                href="https://github.com/Jenemae"
                className="w-10 h-10 flex items-center justify-center rounded-lg border border-white/10 text-zinc-400 hover:text-white hover:border-white transition-all duration-300"
                target="_blank"
                rel="noopener noreferrer"
              >
                <AiFillGithub size={20} />
              </a>
            </li>
            <li className="social-icons !m-0">
              <a
                href="https://web.facebook.com/Dyuy.labastida"
                className="w-10 h-10 flex items-center justify-center rounded-lg border border-white/10 text-zinc-400 hover:text-white hover:border-white transition-all duration-300"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebookF size={18} />
              </a>
            </li>
            <li className="social-icons !m-0">
              <a
                href="https://www.linkedin.com/in/jenemae/"
                className="w-10 h-10 flex items-center justify-center rounded-lg border border-white/10 text-zinc-400 hover:text-white hover:border-white transition-all duration-300"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedinIn size={18} />
              </a>
            </li>
            <li className="social-icons !m-0">
              <a
                href="https://discord.com/users/pi_.void"
                className="w-10 h-10 flex items-center justify-center rounded-lg border border-white/10 text-zinc-400 hover:text-white hover:border-white transition-all duration-300"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaDiscord size={18} />
              </a>
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
